import { render, staticRenderFns } from "./installVideo.vue?vue&type=template&id=63ca28e8&scoped=true&"
import script from "./installVideo.vue?vue&type=script&lang=js&"
export * from "./installVideo.vue?vue&type=script&lang=js&"
import style0 from "./installVideo.vue?vue&type=style&index=0&id=63ca28e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca28e8",
  null
  
)

export default component.exports